import React, {useEffect, useState} from 'react';

import '../../../App.css';
import {useAppDispatch, useAppSelector} from "../../../feature/tools";
import {
    Button,
    Card, Empty,
    Flex,
    Radio
} from "antd";
import Title from "antd/es/typography/Title";
import {providers, StorageProviderSettings} from "../../../storage/providers/StorageProvider";
import {
    loadProjectStorageProvider,
    loadStorageSettings,
    saveProjectStorageProvider, saveStorageSettings
} from "../../../feature/project/storageSlice";
import {useParams} from "react-router-dom";
import {openAccountSettings} from "../../../feature/project/appSettingsSlice";

export const ProjectStorageSettings = (
    props: {
        saveFunction: (saveFunction: () => void) => void
    }
) => {
    const dispatch = useAppDispatch()
    const {projectId} = useParams()
    const storageProviders = useAppSelector(state => state.storageSlice.storageProviderSettings)
    const projectStorageProvider = useAppSelector(state => state.storageSlice.projectStorageProviderSettings)
    const [selectedProvider, setSelectedProvider] = useState<StorageProviderSettings | undefined>(undefined)
    const creator = useAppSelector(state => state.users.creator)
    const user = useAppSelector(state => state.users.currentUser)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        dispatch(loadStorageSettings())
        dispatch(loadProjectStorageProvider({projectId: projectId}))
        setLoading(false)
    }, []);

    useEffect(() => {
        setSelectedProvider(projectStorageProvider)
    }, [projectStorageProvider]);

    useEffect(() => {
        props.saveFunction(() => {
            if (selectedProvider) {
                dispatch(saveProjectStorageProvider({provider: selectedProvider, projectId: projectId}))
            }
        })
    }, [selectedProvider]);

    return (
        <Flex gap={10} vertical={true}>
            <Title level={5} style={{margin: 0, paddingTop: 10}}>Storage Settings</Title>
            {user?.id != creator?.id ?
                <div>You are not a creator of this project, you can not change Storage Settings of the project.<br/><br/>Contact
                    a creator <b>{creator?.email}</b> of the project to enable or disable Storage Providers.</div>
                : <> Select Storage provider you want to use for this project. If you don't see providers you want,
                    please check
                    global settings or if you are not an owner of the project ask project owner to enable providers you
                    need.
                    Once you select a provider, you can't change it.
                    {storageProviders.filter(provider => provider.enabled).length > 0 ?
                        storageProviders.filter(provider => provider.enabled).map(provider =>
                            <Card key={provider.name} style={{cursor: 'pointer'}}
                                  onClick={() => selectedProvider?.id != undefined ? setSelectedProvider(provider) : {}}>
                                <Radio
                                    disabled={selectedProvider?.id != undefined}
                                    style={{alignItems: 'center'}}
                                    checked={selectedProvider && provider.name == selectedProvider.name}
                                    onChange={(e) => {
                                        setSelectedProvider(provider)
                                    }}
                                >
                                    <Flex align={'center'} gap={10}>
                                        {providers.find(p => p.name == provider.name)?.icon}<b>{provider.name}</b>
                                    </Flex>
                                </Radio>
                            </Card>
                        ) : <Empty description={<>Enable at least one Storage Provider in the <Button
                            size={'small'}
                            onClick={() => dispatch(openAccountSettings('storage'))}
                        >Account Settings
                        </Button></>}/>
                    }</>}
        </Flex>
    );
};
